import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class ProjectTaskTypeForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    const view = new CerFormView();
    view.viewMetadata = {
      name: 'projekt-opgave-type', dataApiName: 'ProjectTaskType', text: 'Opgavetyper', textSingular: 'Opgavetype',
      primaryKey: 'num', baseFields: ['id', 'num', 'history']
    };
    view.fieldMetadata = [
      { name: 'num', text: 'Opgavetype' },
      { name: 'name', text: 'Opgavetypenavn' },
      { name: 'status', text: 'Opgavestatus', foreignKeyTableName: 'ProjectTaskStatus', foreignKeyField: 'num', foreignKeySortFields: ['id'] },
      { name: 'responsibleTeam', text: 'Opgaveteam', foreignKeyTableName: 'Team', foreignKeyField: 'num' },
      { name: 'responsibleUser', text: 'Opgaveansvarlig', foreignKeyTableName: 'User', foreignKeyField: 'num' },
      { name: 'product', text: 'Specifik udgivelse?', format: 'CheckBox' },
      { name: 'productRoles', text: 'Kontakt tilknytning?', format: 'CheckBox' }
    ];

    viewSet.viewAdd(view);
  }
}
